export const BASE_URL_BY_SYSTEM = {
    ESOC: {
        OG: {
            local: 'http://localhost:8000',
            development: 'https://cosmic.development.luna.nasa.gov',
            staging: 'https://cosmic.staging.luna.nasa.gov',
            production: 'https://cosmic.luna.nasa.gov'
        },
        CDOCS: {
            local: 'http://localhost:4700',
            development: 'https://docs.cosmic.development.luna.nasa.gov',
            staging: 'https://docs.cosmic.staging.luna.nasa.gov',
            production: 'https://docs.cosmic.luna.nasa.gov'
        },
        KNOWLEDGE_BASE: {
            local: 'http://localhost:8081',
            development: 'http://knowledge.cosmic.development.luna.nasa.gov',
            staging: 'http://knowledge.cosmic.staging.luna.nasa.gov',
            production: 'http://knowledge.cosmic.luna.nasa.gov'
        },
        RISK: {
            local: 'http://localhost:4600',
            development: 'https://risk.cosmic.development.luna.nasa.gov',
            staging: 'https://risk.cosmic.staging.luna.nasa.gov',
            production: 'https://risk.cosmic.luna.nasa.gov'
        },
        LOGISTICS: {
            local: 'http://localhost:4400',
            development: 'https://logistics.cosmic.development.luna.nasa.gov',
            staging: 'https://logistics.cosmic.staging.luna.nasa.gov',
            production: 'https://logistics.cosmic.luna.nasa.gov'
        }
    }
};
